import React from 'react';
import ReactDOM from 'react-dom';
import PortDestinations from '../components/PortDestinations';

export function renderPortDestinations(field, cell, graph, updatePorts, updatePortLinks) {
  const container = document.createElement('div');

  ReactDOM.render(
    <PortDestinations cell={cell} graph={graph} updatePorts={updatePorts} updatePortLinks={updatePortLinks} />,
    container
  );

  return container;
}
